/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { StringUtils } from "abweb/utils/StringUtils";
import * as React from "react";
export function AbErrorStackTrace({
  text
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ab-error-stack-trace"
  }, StringUtils.splitLines(text).map((line, index) => /*#__PURE__*/React.createElement("div", {
    key: `line${index}`,
    tabIndex: index
  }, line)));
}
//# sourceMappingURL=AbErrorStackTrace.js.map
